import styled from 'styled-components'
import {  FontSizeText, LinkAssets } from '../../assets'

export const PlatformDescription = styled.p`
    text-align: center;
    margin-top: 30px;
    font-size: ${FontSizeText};
    line-height: 1.29;
    a {
        color: ${LinkAssets.primary.color} !important;
    }
`
